<template>
  <action-modal :is-open="true" @close="close">
    <span slot="title">{{ title }}</span>
    <div class="mt-6">
      <v-list three-line>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Product Code</v-list-item-title>
            <v-list-item-subtitle>{{ item.productCode }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Manufacturer</v-list-item-title>
            <v-list-item-subtitle>{{ item.manufacturer }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Category</v-list-item-title>
            <v-list-item-subtitle>{{
              item.category.name
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="item.subcategory">
          <v-list-item-content>
            <v-list-item-title>Subcategory</v-list-item-title>
            <v-list-item-subtitle>{{
              item.subcategory.name
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Description</v-list-item-title>
            <v-list-item-subtitle>{{
              item.description[0].value
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-for="(field, index) in category.fieldSettings"
          :key="index"
        >
          <v-list-item-title>{{ field.text }}</v-list-item-title>
          <v-list-item-subtitle>{{ item[field.key] }}</v-list-item-subtitle>
        </v-list-item>
      </v-list>
      <v-layout mt-4>
        <v-flex xs12 sm8 md4 pa-2>
          <v-text-field
            v-model="quantity"
            label="Quantity"
            type="number"
            outlined
            dense
          />
        </v-flex>
      </v-layout>
    </div>
    <div slot="actions">
      <v-layout justify-start>
        <v-btn @click="add" :disabled="!valid" color="primary">Add</v-btn>
      </v-layout>
    </div>
  </action-modal>
</template>

<script>
import ActionModal from "./ActionModal";
import commonFields from "../../../modules/commonProductFields";
import { findKey, get } from "lodash";
import ImagesContainer from "@/components/shared/ImagesContainer";
import { Carousel, Slide } from "vue-carousel";
export default {
  name: "AddItemModal",
  props: {
    categories: {
      type: Array,
      required: true,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    distributors: {
      type: Array,
    },
    item: {
      type: Object,
      required: true,
    },
    requireDistributors: {
      type: Boolean,
    },
  },
  data() {
    return {
      quantity: 1,
      distributor: null,
      commonFields,
    };
  },
  components: {
    ActionModal,
  },
  computed: {
    category() {
      const { categories, item } = this;
      return categories.find((cat) => {
        return cat._id === item.category._id;
      });
    },
    open() {
      return this.isOpen;
    },
    valid() {
      return this.requireDistributors
        ? this.quantity > 0 && this.distributor
        : this.quantity > 0;
    },
    fields() {
      const { item, commonFields } = this;
      const display = [];

      commonFields.forEach((field) => {
        const { path, label } = field;
        const value = get(item, path);
        if (value) {
          // Some common fields might be missing, like subcategory
          display.push({
            label,
            value: get(item, path),
          });
        }
      });

      const { attributes } = item;
      attributes.forEach((attr) => {
        const { text, value } = attr;
        display.push({
          label: text,
          value,
        });
      });

      if (item.price) {
        display.push({
          label: "Price",
          value: item.price.formattedPrice,
        });
      }

      return display;
    },
  },
  methods: {
    getTableHeader(value) {
      return findKey(value);
    },
    add() {
      const { quantity, distributor, item } = this;
      const itemCtx = {
        item,
        quantity,
        distributor,
      };

      this.$emit("addItem", itemCtx);
      this.close();
    },
    close() {
      this.$emit("update:addItemModal", false);
    },
  },
};
</script>

<style scoped></style>
